import React, { useRef } from "react";
import PropTypes from 'prop-types';
import { Row, Col, Card, FormText, FormGroup, Button } from "reactstrap";
import SignaturePad from "react-signature-canvas";
import styles from "components/styles.module.scss";
import { convertToBase64, dataURLtoFile } from "utills/index.js";
import { BEHAVIOUR } from 'helpers/constants';
import { getLocalizedText } from 'helpers/language';

const SignatureComponent = (props) => {
  const { data, index, isResponseWrong, language, errors } = props;
  const answer = data.answer;
  const sigRef = useRef();

  const clearSignature = () => {
    sigRef.current.clear();
    data.setSelectedOption({ ...(answer?.[0] || {}), value: undefined });
  };

  const handleSignatureEnd = async () => {
    const dataUrlImg = sigRef.current.getTrimmedCanvas().toDataURL("image/png");
    const imageFile = dataURLtoFile(dataUrlImg, "signature");
    data.setSelectedOption({
      ...(answer?.[0] || {}),
      value: await convertToBase64(imageFile),
    });
  };

  return (
    <Card
      className={
        isResponseWrong
          ? `${styles["highlight-div"]} ${styles["card-ui"]} m-3 p-3`
          : `${styles["card-ui"]} m-3 p-3`
      }
    >
      <Row>
        <Col md={11} className={`${styles["custom-col"]} ps-1`}>
          <span>
            <span>
              {data.behaviour === BEHAVIOUR.MANDATORY ? "*" : null}
            </span>
            {index + 1}.
          </span>
          <div
            className={
              data.behaviour === BEHAVIOUR.MANDATORY
                ? `${styles["questions-ui"]} pe-0 ps-2`
                : "ps-2"
            }
            dangerouslySetInnerHTML={{
              __html: getLocalizedText(language, data.question, data.sp_question),
            }}
          ></div>
        </Col>
      </Row>
      <div className={`${styles["options-margin"]} mt-2 custom-input-label`}>
        <FormGroup>
          <SignaturePad
            penColor={"#000000"}
            maxWidth={2}
            canvasProps={{ className: `${styles["SigPad"]}` }}
            ref={sigRef}
            onEnd={handleSignatureEnd}
            clearOnResize={false}
          />
          <div>
            <Button
              isColor="primary"
              onClick={clearSignature}
              className={`${styles["clear-signature"]}`}
            >
              Clear
            </Button>
          </div>
        </FormGroup>
        <div>
          <FormText className={styles["error-text"]} color="danger">
            {errors}
          </FormText>
        </div>
      </div>
    </Card>
  );
};

SignatureComponent.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isResponseWrong: PropTypes.bool,
  errors: PropTypes.string,
  language: PropTypes.string,
};

export default SignatureComponent;
